import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { Row } from '@kerfjs/ui/row';
import type { SafeHtml } from 'kerfjs';
import { Bot, TriangleAlert } from 'lucide';

import { type IntakeLine } from '../../../data/state.js';
import { type LineStatusKind, lineStatusMarkers } from '../../../lib/line-status.js';

const LINE_STATUS_ICON: Record<LineStatusKind, typeof Bot> = {
  'ai-detected': Bot,
  'needs-clarification': TriangleAlert,
};

/** `question` is the reviewer's open clarification question on the line, if any (HS2-4YCV66). */
export function StatusIconCell({ line, question }: { line: IntakeLine; question?: string }): SafeHtml {
  const markers = lineStatusMarkers(line, question);
  if (markers.length === 0) return <></>;
  return (
    // One horizontal row of markers, so several never stack into a tall cell (HS2-P1YNNS).
    <Row
      gap="2xs"
      vAlign="middle"
      className="status-icon-cell"
      rootAttributes={{ 'data-layout': markers.length > 1 ? 'row' : 'single' }}
    >
      {markers.map((marker) => {
        return (
          <span
            class="status-icon"
            data-kind={marker.kind}
            data-key={marker.kind}
            title={marker.label}
            aria-label={marker.label}
          >
            <LucideIcon icon={LINE_STATUS_ICON[marker.kind]} name={marker.label} />
          </span>
        );
      })}
    </Row>
  );
}
